export function isJpegFile (file) {
    return !!file && /\.(jpe?g|jpe|jfif)$/i.test(file.name) &&
        (!file.type || /^(image\/p?jpeg|application\/octet-stream)$/i.test(file.type))
}

export function compareFileNames (a, b) {
    return String(a.name).localeCompare(String(b.name), 'ja', { numeric: true, sensitivity: 'base' })
}

export async function readDirectoryFiles (entry) {
    if (entry.isFile) {
        const file = await new Promise((resolve, reject) => entry.file(resolve, reject))
        return [file]
    }
    if (!entry.isDirectory) return []

    const reader = entry.createReader()
    const files = []
    while (true) {
        const entries = await new Promise((resolve, reject) => reader.readEntries(resolve, reject))
        if (!entries.length) break
        for (const child of entries) {
            files.push(...await readDirectoryFiles(child))
        }
    }
    return files.sort(compareFileNames)
}



// WEBPACK FOOTER //
// ./src/helpers/uploadFiles.js